import { htmlSafe } from '@ember/template'

/**
 * These are lodash templates. https://lodash.com/docs/4.17.15#template
 *
 * They are used by the FormSelect component to render options, with data values injected.
 *
 * --- HTML safe & escaping values
 *
 * We are currently using these templates to render HTML, so they need to be marked htmlSafe.
 *
 * Because of this, we need to take special care not to mark raw user-defined values as htmlsafe. We can do this by
 * escaping user-defined values before marking the template string safe.
 *
 * <%-value%> in a lodash template marks a value that should be html escaped.
 * <%=value%> or ${value} just means render as is
 *
 * The text value is often a student/teacher/class name (user-defined) so those are escaped.
 *
 * --- Icons
 *
 * Note, these templates rely on the form-components addon running dom.i2svg to convert the html <i> tags to svg icons
 */

const faSVGClasses = `box-content overflow-visible inline-block h-4 align-[-0.125em]`

const faUser = `<svg class="${faSVGClasses} mr-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path></svg>`
const faUsers = `<svg class="${faSVGClasses} text-medal-silver" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="users" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" data-fa-i2svg=""><path fill="currentColor" d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"></path></svg>`

export const optionTemplate = htmlSafe(
  `<div class="flex">
     <div>${faUser}<%-text%></div>
     <div>${faUsers}<span data-test-student-count><%=studentCount%></span></div>
   </div>`,
)

export const optionTemplateSubLevel = htmlSafe(
  `<div class="flex">
    <div><%-text%></div>
    <div>${faUsers}<span data-test-student-count><%=studentCount%></span></div>
  </div>`,
)

export const optionTemplateUserIconText = htmlSafe('${faUser} <%-text%>')
